import React, { useMemo } from 'react';
import styled from "styled-components";
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { useTranslation } from "react-i18next";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { useDispatch, useSelector } from "react-redux";
import { selectAllOfficeEntities } from "@features/desks/store/advanceHotDeskingSetup.duck";
import { getFullOfficeTitle } from "@shared/utils/OfficeHelper";
import { selectCalendarDate } from "@shared/store/dashboard.duck";
import { DATE_FORMAT } from "@shared/utils/DateUtils";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { DialogIdentifiers, openDialog } from "@shared/store/dialog.duck";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function VisitorBookingHeader(props: Props) {
  const {t} = useTranslation();
  const {office} = props;
  const dispatch = useDispatch();
  const allOffices = useSelector(selectAllOfficeEntities);
  const calendarDate = useSelector(selectCalendarDate);

  const officeLabel = useMemo(() => {
    return getFullOfficeTitle(office, allOffices, ', ');
  }, [allOffices, office]);

  const backUrl = useMemo(() => {
    let url = '/whereabouts/office-view';
    let params: string[] = [];
    if (office) {
      params.push(`office=${office.id}`);
    }
    if (calendarDate) {
      params.push(`date=${calendarDate.format(DATE_FORMAT)}`);
    }

    if (params.length > 0) {
      url += ('?' + params.join('&'));
    }

    return url;
  }, [office, calendarDate]);

  const onClick = () => {
    window.location.href = backUrl;
  }

  const onFiltersClick = () => {
    dispatch(openDialog(DialogIdentifiers.VisitorBookingFilterDialog));
  }

  return (
    <Container>
      <GoBackButton onClick={onClick} />
      <HeadlineSmall>{t('visitor-booking.visitor-office-title', {officeName: officeLabel})}</HeadlineSmall>
      <OutlineButton text={"button.filters"} click={onFiltersClick} size={ButtonSize.Small} className={"visitorBooking_filterButton"} />
    </Container>
  )
}

interface Props {
  office: OfficeEntity;
}

const Container = styled.div`
  display: flex;
  padding: 16px 0;
  flex-direction: column;
  .visitorBooking_filterButton {
    margin: 10px auto 0 auto;
  }
  & > h3 {
    margin: 0 auto;
  }
  @media (${tablet}) {
    flex-direction: row;
    .visitorBooking_filterButton {
      display: none;
    }
  }
`
